import React from "react"
import { FaChevronDown } from "react-icons/fa"

import styles from "../../styles/global.module.scss"

export default class Accordion extends React.Component {
  static defaultProps = {
    items: [],
    className: "",
  }

  state = {
    showAccordion: false,
  }

  handleClick = event => {
    //Check to see if active class is on element
    //Add class to element if active is not applied
    let accActive = `${styles.active}`
    if (event.target.classList.contains(accActive)) {
      event.target.classList.remove(accActive)
    } else {
      event.target.classList.add(accActive)
    }
  }

  //   handleClick = event => event.target.classList.toggle("active")

  render() {
    const { items } = this.props
    const accordionVisable = this.state.showAccordion ? `${styles.active}` : ""

    return (
      <div className={styles.accordion}>
        {!!items &&
          items.map((item, index) => (
            <div
              className={`${styles.accordion_item} ${accordionVisable}`}
              key={index}
              onClick={this.handleClick}
              onKeyDown={this.handleClick}
              role="button"
              tabIndex={index}
              aria-label="Show FAQ"
            >
              <h3 className={styles.flex}>
                <span>{item.title}</span>
                <FaChevronDown />
              </h3>
              <div className={styles.description}>
                {item.description} <br />
                {item.link && (
                  <div href={item.link} className={styles.button}>
                    {item.linkTitle}
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
    )
  }
}
